var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2165_11185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.75 31.3344C12.9379 31.3344 7.41562 25.8121 7.41562 19C7.41562 12.1879 12.9379 6.66559 19.75 6.66559C26.5622 6.66559 32.0845 12.1879 32.0845 19C32.0845 25.8121 26.5622 31.3344 19.75 31.3344Z",
    fill: "#FFC114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0287 10.2787C6.23197 15.0754 6.23197 22.8623 11.0287 27.7213C15.8254 32.518 23.6123 32.518 28.4713 27.7213",
    fill: "#FCA12A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7401 5.29508L19.7499 0L16.7598 5.29508H22.7401Z",
    fill: "#FFC114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5008 5.29508L19.75 0L16.7598 5.29508H19.5008Z",
    fill: "#FCA12A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7598 32.7049L19.7499 38L22.7401 32.7049H16.7598Z",
    fill: "#FFC114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9991 32.7049L19.7499 38L22.7401 32.7049H19.9991Z",
    fill: "#FCA12A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04504 16.0098L0.749962 19L6.04504 21.9902V16.0098Z",
    fill: "#FFC114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04504 19.2492L0.749962 19L6.04504 21.9902V19.2492Z",
    fill: "#FCA12A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4549 21.9902L38.75 19L33.4549 16.0098V21.9902Z",
    fill: "#FFC114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4549 18.7508L38.75 19L33.4549 16.0098V18.7508Z",
    fill: "#FCA12A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9631 6.97703L6.1074 5.35736L7.72707 11.2131L11.9631 6.97703Z",
    fill: "#FFC114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6582 9.28195L6.10738 5.35736L7.72706 11.2131L9.6582 9.28195Z",
    fill: "#FCA12A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5368 31.0229L33.3926 32.6426L31.7729 26.7869L27.5368 31.0229Z",
    fill: "#FFC114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8418 28.718L33.3926 32.6426L31.7729 26.7869L29.8418 28.718Z",
    fill: "#FCA12A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72707 26.7869L6.1074 32.6426L11.9631 31.0229L7.72707 26.7869Z",
    fill: "#FFC114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.032 29.0918L6.1074 32.6426L11.9631 31.0229L10.032 29.0918Z",
    fill: "#FCA12A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7729 11.2131L33.3926 5.35736L27.5368 6.97703L31.7729 11.2131Z",
    fill: "#FFC114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.468 8.90818L33.3926 5.35736L27.5368 6.97703L29.468 8.90818Z",
    fill: "#FCA12A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2165_11185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "matrix(-1 0 0 1 38.75 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.81209ed48f0426dc6ec5fdd6b38728a4.svg";
export { ForwardRef as ReactComponent };